import { Toggle } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import JsonView from '../../../../../components/JsonView'
import { cleanPolicyObject } from '../../policy_management/utils'
import PolicyDetailsFrame from '../PolicyDetailsFrame'
import PrettyView from './PrettyView'

const propTypes = {
  /**
   * Policy payload (raw policy) object
   */
  rawPolicy: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Form options map
   */
  policyFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Sanitize checkbox component
   */
  sanitizeCheck: PropTypes.node,
  /**
   * If true, hides header (title) and show toggle in line with content
   */
  headless: PropTypes.bool,
  /**
   * Inputs to hide in pretty view only
   */
  hiddenInputs: PropTypes.arrayOf(PropTypes.string),
}

function JsonPrettyView(props) {
  const {
    rawPolicy = {},
    policyFormOptionsMap = {},
    sanitizeCheck = null,
    headless = false,
    hiddenInputs = [],
  } = props ?? {}

  const intl = useIntl()

  const cleanPolicy = useMemo(() => cleanPolicyObject(rawPolicy), [rawPolicy])

  const [showJsonView, setShowJsonView] = useState(false)

  return (
    <PolicyDetailsFrame
      sanitizeCheck={sanitizeCheck}
      headless={headless}
      toggle={
        <Toggle
          id="toggleJsonView"
          labelText={intl.formatMessage({ id: 'POLICY_TEMPLATES.JSON_VIEW' })}
          checked={showJsonView}
          onChange={setShowJsonView}
        />
      }
    >
      {showJsonView ? (
        <JsonView rawJson={cleanPolicy} colorize />
      ) : (
        <PrettyView policyFormOptionsMap={policyFormOptionsMap} rawPolicy={rawPolicy} hiddenInputs={hiddenInputs} />
      )}
    </PolicyDetailsFrame>
  )
}

JsonPrettyView.propTypes = propTypes

export default JsonPrettyView
